module.exports = __webpack_public_path__ + "img/partnine_pic.1f1d3e70.png";